/**
 * Labstep
 *
 * @module components/PermissionRole/Form/Edit
 * @desc PermissionRole Form Edit
 */

import { fieldName } from 'labstep-web/components/PermissionRole/Form/fields';
import { EditFormUpdateContainer as EditForm } from 'labstep-web/core/Form/Edit';
import type React from 'react';
import type { IPermissionRoleFormEditProps } from './types';

export const PermissionRoleFormEdit: React.FC<
  IPermissionRoleFormEditProps
> = ({ permissionRole, ...rest }) => (
  <EditForm
    autoFocus
    entityName={permissionRole.entityName}
    defaultValues={{ name: permissionRole.name }}
    entity={permissionRole}
    fields={[fieldName]}
    {...rest}
  />
);
